import { RadioButton } from '@monash/portal-react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import cs from '../../get-api-responses.module.scss';
import { useState } from 'react';

const CreationOptions = () => {
  const { setValue } = useFormContext();

  const [shouldCreatePortalPreferences, setShouldCreatePortalPreferences] =
    useState(false);

  const watchedCreatePortalPreferencesMode = useWatch({
    name: 'options.createPortalPreferences.mode',
  });

  return (
    <div className={cs.sectionContainer}>
      <div className={cs.sectionContainer}>
        <div className={cs.inputContainer}>
          <h3>Create portal preferences?</h3>
          <div>
            This initialises portal preferences in firestore for the created
            user
          </div>
          <div className={cs.radioGroup}>
            <RadioButton
              label="Yes"
              onChange={() => {
                setValue('options.createPortalPreferences.mode', 'default');
                setShouldCreatePortalPreferences(true);
              }}
              on={shouldCreatePortalPreferences}
            />
            <RadioButton
              label="No"
              onChange={() => setShouldCreatePortalPreferences(false)}
              on={!shouldCreatePortalPreferences}
            />
          </div>
        </div>
        {shouldCreatePortalPreferences && (
          <div className={cs.sectionContainer}>
            <div className={cs.inputContainer}>
              <h3>Mode</h3>
              <div className={cs.radioGroup}>
                <Controller
                  name="options.createPortalPreferences.mode"
                  render={({ field: { value, onChange } }) => (
                    <>
                      <RadioButton
                        label="Default"
                        onChange={() => onChange('default')}
                        on={value === 'default'}
                      />
                      {/* TODO: in future, add support for "custom" option */}
                      {/* <RadioButton
                            label="Custom"
                            onChange={() => onChange("custom")}
                            on={value === "custom"}
                          /> */}
                    </>
                  )}
                />
              </div>
            </div>
            {watchedCreatePortalPreferencesMode === 'default' && (
              <div className={cs.inputContainer}>
                <h3>Primary location</h3>
                <div className={cs.radioGroup}>
                  <Controller
                    name="options.createPortalPreferences.primaryLocation"
                    render={({ field: { value, onChange } }) => (
                      <>
                        <RadioButton
                          label="Default"
                          onChange={() => onChange(undefined)}
                          on={!value}
                        />
                        <RadioButton
                          label="Australian"
                          onChange={() => onChange('Australian')}
                          on={value === 'Australian'}
                        />
                        <RadioButton
                          label="Malaysian"
                          onChange={() => onChange('Malaysian')}
                          on={value === 'Malaysian'}
                        />
                        <RadioButton
                          label="MonashCollege"
                          onChange={() => onChange('MonashCollege')}
                          on={value === 'MonashCollege'}
                        />
                        <RadioButton
                          label="Indonesian"
                          onChange={() => onChange('Indonesian')}
                          on={value === 'Indonesian'}
                        />
                      </>
                    )}
                  />
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CreationOptions;
